import { useEffect, useRef, useState } from 'react';

export const useScrollShadows = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [shadows, setShadows] = useState({ left: false, right: false });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const update = () => {
      setShadows({
        left: el.scrollLeft > 0,
        right: el.scrollLeft + el.clientWidth < el.scrollWidth,
      });
    };

    update();
    el.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      el.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return { ref, shadows };
};
